import { Field } from "formik";
import ValidationError from "./ValidationError";

export function FieldWithLabel(props: {
  fieldId: string;
  fieldName: string;
  fieldType?: string;
  label: string;
  placeholder?: string;
  helperText?: string;
  isRequired?: boolean;
  className?: string;
  textArea?: boolean;
  touched?: boolean;
  error?: string;
}) {
  const {
    fieldName,
    fieldType,
    fieldId,
    label,
    placeholder,
    helperText,
    isRequired,
    className,
    textArea,
  } = props;

  return (
    <div
      className={`d-flex flex-column position-relative ${
        className ? className : ""
      }`}
    >
      <label className="form-label" htmlFor={fieldId}>
        {label}
        {isRequired ? (
          <span className="text-danger" aria-hidden="true">
            {" *"}
          </span>
        ) : null}
      </label>

      {textArea ? (
        <Field
          autoComplete="off"
          className={`form-control w-auto col-auto ${
            props.touched && props.error !== undefined ? " is-invalid" : ""
          }`}
          id={fieldId}
          name={fieldName}
          placeholder={placeholder}
          as="textarea"
          rows={2}
        />
      ) : (
        <Field
          autoComplete="off"
          className={`form-control w-auto col-auto ${
            props.touched && props.error !== undefined ? " is-invalid" : ""
          }`}
          id={fieldId}
          type={fieldType}
          name={fieldName}
          placeholder={placeholder}
        />
      )}
      {helperText ? <div className="form-text mb-0">{helperText}</div> : null}
      <ValidationError
        show={props.touched && props.error !== undefined}
        error={props.error}
      />
    </div>
  );
}
